import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Highcharts from 'highcharts';

import { getDetailsData } from '../../CycleTimeHistogram/CTHActions';

const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: '#fff',
    type: 'column',
  },
  title: {
    text: '',
  },
  xAxis: {
    labels: {
      style: {
        fontSize: '5px',
      },
    },
    min: 1,
    title: {
      enabled: false,
    },
  },
  yAxis: {
    allowDecimals: false,
    labels: {
      style: {
        fontSize: '6px',
      },
    },
    min: 0,
    gridLineColor: '#F5F5F5',
    gridLineWidth: 1,
    title: {
      enabled: false,
    },
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    series: {
      stickyTracking: false,
    },
    column: {
      pointPadding: 0,
      borderWidth: 0,
      groupPadding: 0,
      shadow: false,
    },
  },
  series: [
    {
      name: 'Data',
      data: [],
    },
  ],
};

class CTHChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    if (this.props.details.series && this.props.details.series.length) {
      this.updateDetails();
    } else if (this.props.data) {
      this.props.getDetailsData(this.props.dates);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data && !_.isEqual(prevProps.data, this.props.data)) {
      this.props.getDetailsData(this.props.dates);
    }

    if (this.props.data.series && prevProps.details != this.props.details) {
      this.updateDetails();
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateDetails() {
    this.chart.update({
      series: [
        {
          color: 'rgba(124, 181, 236, 0.9)',
          data: this.props.details.series,
        },
      ],
    });
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDetailsData: (dates) => dispatch(getDetailsData(dates)),
  };
};

const mapStateToProps = (state) => {
  return {
    dates: state.filters.dates,
    details: state.cth.details,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTHChart);
